module.exports = __webpack_public_path__ + "26d088d04586e6873c3ab136281095aa.png";